import {
    InvoiceControlerModel,
    InvoiceModel,
    InvoiceBaobabModel,
    ReservationModelWithModelsIncluded,
    StayOverOverlap,
    PriceOfferInterval,
    PriceOffer,
    InvoiceModelWithInvoiceItems,
    GroupInfoWithReservations,
    InvoiceItemsModel,
    ReservationStatus,
    PosTerminalConsumption,
} from '@common/modelDefinition';
import {
    InvoiceTypeEnum,
    RoomCleaningRequest,
    ApplyCurrentOffer,
    ReservationTypeBody,
    LoadCheckoutInvoice,
} from './interfaces';
import {
    getPendingInvoiceForReservation,
    getBelongingReservation,
    getBelongingGroupReservation,
    setReservationInvoiceProperties,
    getReservationInvoicePreview,
    receptionSetToggleStates,
    createOrJoinNotConnectedConsumptionInvoices as _createOrJoinNotConnectedConsumptionInvoices,
    saveInvoice as _saveInvoice,
    issuePosInvoice as _issuePosInvoice,
    loadPosTerminalPendigInvoice as _loadPosTerminalPendigInvoice,
    updateInvoiceAndRecalculateStatus as _updateInvoiceAndRecalculateStatus,
} from './api';
import { saveGroupRes, saveOrUpdateReservation } from '@pages/newReservations/api';
import { checkReservationFromGroupOfferMismatch } from '@pages/newReservations/utils';
import { getInvoiceTemplate } from '../invoicePresenter/utils';
import useStore from '@data/state/zustand';
import { startGlobalLoading, stopGlobalLoading } from '@components/loaders/globalLoading';
import rest from '@data/restWrapper';


// Round to 2 decimal places - handles floating point precision issues
function round(num: number): number {
    var m = Number((Math.abs(num) * 100).toPrecision(15));
    return (Math.round(m) / 100) * Math.sign(num);
}
export const openInNewTab = (url: string) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
};

export const validateAction = () => {
    //pendingInvoice
    const pendingInvoice: InvoiceModel = useStore.getState().state.checkoutInvoice.invoice.pendingInvoice;
    if (!pendingInvoice) {
        throw new Error('Action called on non pending invoice! Something is wrong!');
    }
};

export const clearInitialBaobab = (location: any | null) => {
    const checkoutDateMismatchsOnLoad: number[] = useStore.getState().state.checkoutInvoice.checkoutDateMismatchs;
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice'], {
        invoice: {},
        invoiceItems: [],
        simpleViewEnabled: false,
        advanceInvoices: [], //nije da treba, ali eto
        proformaInvoices: [], //prethodno izdani predračuni
        stornoInvoices: [], //stornirani računi,
        groupReservationsArray: [],
        reservation: null,
        posTerminalInvoices: [],
        checkoutDateMismatchs: location ? [] : checkoutDateMismatchsOnLoad,
        genuineInvoices: [],
        stayoverOverlap: { overlapReservations: [], option: null, type: null },
        minibarInvoices: [],
        invoiceStornoPreview: null,
        accommodationInvoice: null,
        loyaltyProgram: null,
    });
};

export const setBaobab = (invoiceBabobabModel: InvoiceBaobabModel) => {
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice'], {
        ...invoiceBabobabModel,
    });
};

export const clearInvoicePreview = () => {
    useStore
        .getState()
        .setNestedProperty(['state', 'checkoutInvoice', 'invoicePreview'], { invoice: {}, invoiceItems: [] });
};

export const loadInvoicePreview = async (reservationId: number) => {
    const invoicePreviewInvoice = useStore.getState().state.checkoutInvoice.invoicePreview;
    if (
        invoicePreviewInvoice &&
        invoicePreviewInvoice.reservationId &&
        invoicePreviewInvoice.reservationId === reservationId
    ) {
        clearInvoicePreview();
    } else {
        const { invoice, invoiceItems } = await getReservationInvoicePreview(reservationId);
        invoice.reservationId = reservationId;
        useStore
            .getState()
            .setNestedProperty(['state', 'checkoutInvoice', 'invoicePreview'], { invoice, invoiceItems });
    }
};

export const recalculateReservationInvoice = async () => {
    const invoice = useStore.getState().state.checkoutInvoice.invoice;

    const { reservationId, groupUuid, terminalType } = invoice;
    if (!reservationId && !groupUuid) {
        return null;
    }
    if (terminalType === 'reservation') {
        if (invoice?.connectedInvoices?.length > 0) {
            await addConnectedInvoice(null, reservationId, groupUuid);
        } else {
            await loadCheckoutInvoice({
                reservationId,
                groupUuid,
            });
            setAccommodationInvoice();
        }
    } else if (terminalType === 'reservationConsumption') {
        await addConnectedInvoice(null, reservationId, groupUuid);
    }
};

export const loadCheckoutInvoice = async (props: LoadCheckoutInvoice) => {
    const { reservationId = null, groupUuid = null, location = null } = props;
    if (location) {
        clearInitialBaobab(location);
    }
    clearInvoicePreview();
    const invoiceControlerModel: InvoiceControlerModel = await getPendingInvoiceForReservation(
        reservationId,
        groupUuid,
        InvoiceTypeEnum.geniue
    );

    const accommodationInvoice: InvoiceModelWithInvoiceItems = { ...invoiceControlerModel.invoice };
    accommodationInvoice.InvoiceItems = [...invoiceControlerModel.invoiceItems];
    const invoice = getInvoiceTemplate(invoiceControlerModel.invoice);

    const invoiceItems: InvoiceItemsModel[] = [];

    const reservation: ReservationModelWithModelsIncluded | null = await getBelongingReservation(reservationId);
    const groupReservation: GroupInfoWithReservations | null = await getBelongingGroupReservation(groupUuid);

    const groupReservationsArray: ReservationModelWithModelsIncluded[] = groupReservation
        ? groupReservation.Reservations
            ? groupReservation.Reservations
            : []
        : [];

    const stayoverOverlap = { overlapReservations: [], option: null, type: null };
    const checkoutDateMismatchsOnLoad = useStore.getState().state.checkoutInvoice.checkoutDateMismatchs;
    const loyaltyProgram = useStore.getState().state.checkoutInvoice.loyaltyProgram;

    const checkoutDateMismatchs = location ? invoiceControlerModel.checkoutDateMismatchs : checkoutDateMismatchsOnLoad;
    const invoiceBabobabModel: InvoiceBaobabModel = {
        ...invoiceControlerModel,
        invoice,
        invoiceItems,
        checkoutDateMismatchs,
        reservation,
        groupReservationsArray,
        stayoverOverlap,
        invoiceStornoPreview: null,
        accommodationInvoice: accommodationInvoice,
        loyaltyProgram: loyaltyProgram,
    };
    setBaobab(invoiceBabobabModel);
};

export const setInvoiceProperties = async (propertyName: string, value: string | number | boolean | null) => {
    if (
        propertyName === 'generalDiscountPercentage' ||
        propertyName === 'note' ||
        propertyName === 'partialPayment' ||
        propertyName === 'paymentAmount'
    ) {
        validateAction();
    }
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoice', ...[propertyName]], value);
    const invoiceId = useStore.getState().state.checkoutInvoice.invoice.id;
    const pendingInvoice = useStore.getState().state.checkoutInvoice.invoice.pendingInvoice;
    const connectedInvoices = useStore.getState().state.checkoutInvoice.invoice.connectedInvoices;

    const posTerminalInvoices: InvoiceModelWithInvoiceItems[] =
        useStore.getState().state.checkoutInvoice.posTerminalInvoices;
    const minibarInvoices: InvoiceModelWithInvoiceItems[] = useStore.getState().state.checkoutInvoice.minibarInvoices;
    const proformaInvoices: InvoiceModelWithInvoiceItems[] = useStore.getState().state.checkoutInvoice.proformaInvoices;
    const allProformas: InvoiceModelWithInvoiceItems[] = [];

    for (const posTerminalInvoice of posTerminalInvoices) {
        allProformas.push(posTerminalInvoice);
    }
    for (const minibarInvoice of minibarInvoices) {
        allProformas.push(minibarInvoice);
    }
    for (const proformaInvoice of proformaInvoices) {
        allProformas.push(proformaInvoice);
    }

    const disableChangesOnNonPendingInvoice =
        !pendingInvoice && (propertyName === 'currency' || propertyName === 'locale');
    const setBaobabOnly = disableChangesOnNonPendingInvoice;
    if (!setBaobabOnly) {
        const properties = { [propertyName]: value };
        const { invoice, invoiceItems } = await setReservationInvoiceProperties({ invoiceId, properties });
        useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoice'], invoice);
        useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoiceItems'], invoiceItems);
        const connectedProformas = allProformas.filter((p: any) => connectedInvoices.includes(p.id));
        for (const connectedProforma of connectedProformas) {
            const updatedProforma: InvoiceModelWithInvoiceItems = { ...connectedProforma };
            //@ts-ignore
            updatedProforma[propertyName] = value;
            await _saveInvoice(connectedProforma);
        }
    }
};

export const setInvoiceType = async (invoiceType: number) => {
    validateAction();

    const editedInvoice = useStore.getState().state.checkoutInvoice.invoice;
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoice', 'invoiceType'], invoiceType);
    const invoiceId = useStore.getState().state.checkoutInvoice.invoice.id;
    const properties =
        invoiceType !== InvoiceTypeEnum.proforma && editedInvoice.typeOfPayment === null
            ? { invoiceType, typeOfPayment: 'G' }
            : { invoiceType };
    const invoiceControlerModel: InvoiceControlerModel = await setReservationInvoiceProperties({
        invoiceId,
        properties,
    });
    const { invoice, invoiceItems, availableForAdvancePayment } = invoiceControlerModel;
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoice'], invoice);
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoiceItems'], invoiceItems);
    useStore
        .getState()
        .setNestedProperty(['state', 'checkoutInvoice', 'availableForAdvancePayment'], availableForAdvancePayment);
};

export const setInvoiceCompany = async (
    companyId: number | null,
    reservationId: number | null,
    groupUuid: string | null
) => {
    try {
        startGlobalLoading();
        useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoice', 'companyId'], companyId);
        const invoiceId = useStore.getState().state.checkoutInvoice.invoice.id;
        const properties = companyId ? { companyId } : { companyId, companyInfo: null };
        const { invoice } = await setReservationInvoiceProperties({ invoiceId, properties });
        useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoice'], { ...invoice });
        if (reservationId) {
            const reservation: ReservationModelWithModelsIncluded =
                useStore.getState().state.checkoutInvoice.reservation;
            const newReservation = { ...reservation };
            newReservation.companyId = companyId;
            await saveOrUpdateReservation(newReservation);
        } else if (groupUuid) {
            const groupReservation: GroupInfoWithReservations | null = await getBelongingGroupReservation(groupUuid);
            if (groupReservation) {
                const updateGroup = { ...groupReservation };
                updateGroup.companyId = companyId;
                const reservations = updateGroup.Reservations || [];
                await saveGroupRes(reservations, updateGroup);
            }
        }
        await recalculateReservationInvoice();
        stopGlobalLoading();
    } catch (error) {
        stopGlobalLoading();
    }
};

export const setInvoiceCustomer = async (
    customerId: number | null,
    reservationId: number | null,
    groupUuid: string | null
) => {
    try {
        startGlobalLoading();
        useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoice', 'customerId'], customerId);
        const invoiceId = useStore.getState().state.checkoutInvoice.invoice.id;
        const properties = customerId ? { customerId } : { customerId, customerInfo: null };
        const { invoice } = await setReservationInvoiceProperties({ invoiceId, properties });
        useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoice'], invoice);
        const terminalType = useStore.getState().state.checkoutInvoice.invoice.terminalType;
        if (terminalType === 'reservation') {
            if (reservationId) {
                const reservation: ReservationModelWithModelsIncluded =
                    useStore.getState().state.checkoutInvoice.reservation;
                const newReservation = { ...reservation };
                newReservation.customerId = customerId;
                await saveOrUpdateReservation(newReservation);
            } else if (groupUuid) {
                const groupReservation: GroupInfoWithReservations | null = await getBelongingGroupReservation(
                    groupUuid
                );
                if (groupReservation) {
                    const updateGroup = { ...groupReservation };
                    updateGroup.customerId = customerId;
                    const reservations = updateGroup.Reservations || [];
                    await saveGroupRes(reservations, updateGroup);
                }
            }
        }
        await recalculateReservationInvoice();
        stopGlobalLoading();
    } catch (error) {
        stopGlobalLoading();
    }
};

export const issueInvoice = async (reservationId: number | null, groupUuid: string | null) => {
    validateAction();
    const posTerminalId = useStore.getState().state.selectedPosTerminalId;
    const pendingInvoice = 0; //ovo izbacuje račun iz pending status i pokreće izdavanje računa na backendu
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoice', 'pendingInvoice'], pendingInvoice); //this means, invoice is no more pending!!!
    const targetInvoice = useStore.getState().state.checkoutInvoice.invoice;
    const { id, partialPayment, invoiceType, typeOfPayment } = targetInvoice;
    const availableForAdvancePayment = useStore.getState().state.checkoutInvoice.availableForAdvancePayment;
    const paymentAmount =
        !partialPayment && invoiceType === InvoiceTypeEnum.advance // Ako je avans a nije parcijalno , payment amount je cjelokupni preostali iznos
            ? availableForAdvancePayment
            : useStore.getState().state.checkoutInvoice.invoice.paymentAmount;

    const simpleViewEnabled = useStore.getState().state.checkoutInvoice.simpleViewEnabled || false;

    const properties = { pendingInvoice, paymentAmount, typeOfPayment, posTerminalId };
    await setReservationInvoiceProperties({ invoiceId: id, properties, simpleView: simpleViewEnabled });
    await loadCheckoutInvoice({ reservationId, groupUuid });
};

export const stornoInvoice = async (
    reclamationReason: string | null = null,
    reservationId: number | null,
    groupUuid: string | null,
    stornoInvoiceId?: number
) => {
    //1 za reklamirani račun
    if (reclamationReason === null) {
        throw new Error('You have to give a reason for storning invoice?');
    }
    const invoiceStorno = useStore.getState().state.checkoutInvoice.invoiceStornoPreview;
    const invoiceStornoId = stornoInvoiceId ? stornoInvoiceId : invoiceStorno?.id;
    const properties = { reclamation: 1, reclamationReason };
    if (invoiceStornoId) {
        await setReservationInvoiceProperties({ invoiceId: invoiceStornoId, properties });
        await loadCheckoutInvoice({ reservationId, groupUuid });
    }
};

export const setReclamationReason = async (reclamationReason: string | null = null) => {
    useStore
        .getState()
        .setNestedProperty(
            ['state', 'checkoutInvoice', 'invoiceStornoPreview', 'reclamationReason'],
            reclamationReason
        );
};

export const setInvoiceStornoPreview = (invoice: InvoiceModelWithInvoiceItems | null) => {
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoiceStornoPreview'], invoice);
};

export const getIssuedStornoInvoice = (invoiceId: number) => {
    const stornoInvoices = useStore.getState().state.checkoutInvoice.stornoInvoices;
    const issuedStornoInvoice: InvoiceModel =
        stornoInvoices?.length > 0 ? stornoInvoices.find((i: InvoiceModel) => i.refInvoice === invoiceId) : null;
    return issuedStornoInvoice;
};

export const checkoutReservation = async (
    targetReservation: ReservationModelWithModelsIncluded,
    reservationId: number | null,
    groupUuid: string | null,
    location: any,
    applyCurrentTime: boolean
) => {
    const stayoverOverlap: StayOverOverlap = useStore.getState().state.checkoutInvoice.stayoverOverlap;
    const reservation = { ...targetReservation };

    if (applyCurrentTime) {
        reservation.checkOutTimestamp = new Date().getTime();
    }

    reservation.statusEnum = 4;
    const checkForStayoverOverlapRequired =
        stayoverOverlap?.overlapReservations?.length > 0 &&
        stayoverOverlap?.option &&
        stayoverOverlap?.type === 'checkOut';
    try {
        if (checkForStayoverOverlapRequired) {
            await checkForStayoverOverlap(
                stayoverOverlap,
                reservation,
                targetReservation,
                reservationId,
                groupUuid,
                location
            );
        } else {
            if (reservation && reservation.groupUuid) {
                const groupCover = await rest('/GroupInfo/' + reservation.groupUuid, 'GET');
                await saveGroupRes([reservation], groupCover);
            } else {
                await saveOrUpdateReservation(reservation);
            }
            await loadCheckoutInvoice({ reservationId, groupUuid, location }); // Detektiramo PriceOfferMismatch
        }
    } catch (err: any) {
        if (err.desc && err.desc.length > 0) {
            useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'stayoverOverlap'], {
                overlapReservations: err.desc,
                option: null,
                type: 'checkOut',
            });
        } else {
            console.log(err);
        }
    }
};

export const checkForStayoverOverlap = async (
    stayoverOverlap: StayOverOverlap,
    reservation: ReservationModelWithModelsIncluded,
    targetReservation: ReservationModelWithModelsIncluded | null = null,
    reservationId: number | null,
    groupUuid: string | null,
    location: any
) => {
    const { overlapReservations, option, type } = stayoverOverlap;
    if (overlapReservations.length > 0) {
        const conflictReservation: ReservationModelWithModelsIncluded = { ...overlapReservations[0] };
        if (option === 1) {
            // Odjavi sada i pomakni sljedeću rezervaciju.
            const timeDiference = conflictReservation.checkOutTimestamp - conflictReservation.checkInTimestamp;
            conflictReservation.checkInTimestamp = new Date().setHours(new Date().getHours() + 1);
            conflictReservation.checkOutTimestamp = conflictReservation.checkInTimestamp + timeDiference;
            try {
                await saveOrUpdateReservation(conflictReservation);
            } catch (err: any) {
                if (err.desc && err.desc.length > 0) {
                    const overlapReservations = err.desc;
                    overlapReservations.push(conflictReservation);
                    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'stayoverOverlap'], {
                        overlapReservations: overlapReservations,
                        option: null,
                        type: type,
                    });
                } else {
                    console.log(err);
                }
            }
        } else if (option === 2) {
            //Odjavi do početka sljedeće rezervacije.
            const conflictReservationCheckIn = new Date(conflictReservation.checkInTimestamp);
            reservation.checkOutTimestamp = conflictReservationCheckIn.setHours(
                conflictReservationCheckIn.getHours() - 1
            );
        } else if (option === 3 && targetReservation) {
            const { checkOutTimestamp } = targetReservation;
            //Odjavi na inicijalni checkout.
            reservation.checkOutTimestamp = checkOutTimestamp;
        }

        await saveOrUpdateReservation(reservation);
        if (type === 'applyCurrentDate' && option === 1) {
            await loadCheckoutInvoice({ reservationId, groupUuid, location }); // Račun dobiva nove vrijednosti
        } else {
            const updatedReservation: ReservationModelWithModelsIncluded | null = await getBelongingReservation(
                reservationId
            );
            const groupReservation: GroupInfoWithReservations | null = await getBelongingGroupReservation(groupUuid);
            const groupReservationsArray: ReservationModelWithModelsIncluded[] = groupReservation
                ? groupReservation.Reservations
                    ? groupReservation.Reservations
                    : []
                : [];
            useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'reservation'], updatedReservation);
            useStore
                .getState()
                .setNestedProperty(['state', 'checkoutInvoice', 'groupReservationsArray'], groupReservationsArray);
        }
    }
};

export const applyCurrentCheckoutDate = async (
    targetReservation: ReservationModelWithModelsIncluded,
    location: any,
    reservationId: number | null,
    groupUuid: string | null
) => {
    const stayoverOverlap: StayOverOverlap = useStore.getState().state.checkoutInvoice.stayoverOverlap;
    const reservation = { ...targetReservation };
    reservation.checkOutTimestamp = new Date().getTime();
    const checkForStayoverOverlapRequired =
        stayoverOverlap?.overlapReservations.length > 0 &&
        stayoverOverlap?.option &&
        stayoverOverlap?.type === 'applyCurrentDate';
    try {
        if (checkForStayoverOverlapRequired) {
            await checkForStayoverOverlap(
                stayoverOverlap,
                reservation,
                targetReservation,
                reservationId,
                groupUuid,
                location
            );
        } else {
            await saveOrUpdateReservation(reservation);

            await loadCheckoutInvoice({ reservationId, groupUuid, location }); // Najlakše je ponovo učitati sve, invoice ažuriran
        }
    } catch (err: any) {
        if (err.desc && err.desc.length > 0) {
            useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'stayoverOverlap'], {
                overlapReservations: err.desc,
                option: null,
                type: 'applyCurrentDate',
            });
        } else {
            console.log(err);
        }
    }
};

export const ignoreCheckoutDateMismatch = (reservation: ReservationModelWithModelsIncluded) => {
    const newCheckoutDateMismatchs: number[] = [];
    useStore
        .getState()
        .setNestedProperty(['state', 'checkoutInvoice', 'checkoutDateMismatchs'], newCheckoutDateMismatchs);
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'stayoverOverlap'], {
        overlapReservations: [],
        option: null,
        type: null,
    });
};

export const stayOverActions = (
    overlapReservations: ReservationModelWithModelsIncluded[],
    option: number,
    type: string
) => {
    const selectedOption: number = useStore.getState().state.checkoutInvoice.stayoverOverlap.option;
    if (option === selectedOption) {
        useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'stayoverOverlap'], {
            overlapReservations: overlapReservations,
            option: null,
            type: type,
        });
    } else {
        useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'stayoverOverlap'], {
            overlapReservations: overlapReservations,
            option: option,
            type: type,
        });
    }
};

export const makeRoomCleaningRequest = async (reservation: ReservationModelWithModelsIncluded) => {
    const roomMap = useStore.getState().map.RoomInfo();
    const room = roomMap?.[reservation.roomInfoId];
    if (room && room.remoteDeviceId) {
        const roomCleaningRequest: RoomCleaningRequest = {
            key: 'alarm_cleaningService', //cleaning request index
            value: true, //set on state!!!
        };
        const { remoteDeviceId } = room;
        await receptionSetToggleStates(remoteDeviceId, roomCleaningRequest);
    }
};

export const addConnectedInvoice = async (
    targetInvoiceId: number | null,
    reservationId: number | null,
    groupUuid: string | null
) => {
    const connectedInvoicesState: number[] = useStore.getState().state.checkoutInvoice.invoice.connectedInvoices; //backend ga je već parisrao u array
    let connectedInvoices = connectedInvoicesState ? [...connectedInvoicesState] : [];

    if (targetInvoiceId && connectedInvoices.includes(targetInvoiceId)) {
        connectedInvoices = connectedInvoices.filter((c) => Number(c) !== targetInvoiceId);
    } else {
        if (targetInvoiceId) {
            connectedInvoices.push(targetInvoiceId);
        }
    }

    const activeInvoice: InvoiceModel = useStore.getState().state.checkoutInvoice.invoice;
    const originInvoiceId: number = useStore.getState().state.checkoutInvoice.invoice.id;
    const { terminalType } = activeInvoice;
    const properties = { connectedInvoices };
    const { invoice, invoiceItems } = await setReservationInvoiceProperties({
        invoiceId: originInvoiceId,
        properties,
        terminalType,
    });

    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoice'], invoice);
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoiceItems'], invoiceItems);

    if (terminalType === 'reservationConsumption' && connectedInvoices.length === 0) {
        await loadCheckoutInvoice({ reservationId, groupUuid });
    }
};

export const applyCurrentOffer = async (props: ApplyCurrentOffer) => {
    const { reservationId = null, groupUuid = null, priceOfferIntervals } = props;

     if (reservationId) {
        // DOHVATI SVJEŽU REZERVACIJU S BACKENDA umjesto iz store-a!
        const reservation: ReservationModelWithModelsIncluded = await rest(`/Reservation/${reservationId}`, 'GET');

        if (!reservation) {
            throw new Error('Reservation not found!');
        }
        if (reservation?.statusEnum === ReservationStatus.closed) {
            throw new Error('Reservation is closed!');
        } else {
            const {
                accommodationPriceListId,
                checkInTimestamp,
                checkOutTimestamp,
                adultsNumber,
                childrenNumber,
                id,
                rememberedAccommodationPriceInfo,
                openPrice,
                canceledReservationInvoicingStatus,
                board,
                guestTaxConfig,
            } = reservation;

            const reservationPriceOfferIntervals: PriceOfferInterval[] = priceOfferIntervals[id];

            if (rememberedAccommodationPriceInfo) {
                // Parsiraj guestTaxConfig ako je string
                let parsedGuestTaxConfig = null;
                if (guestTaxConfig) {
                    if (typeof guestTaxConfig === 'string') {
                        try {
                            parsedGuestTaxConfig = JSON.parse(guestTaxConfig);
                        } catch (e) {
                            parsedGuestTaxConfig = null;
                        }
                    } else {
                        parsedGuestTaxConfig = guestTaxConfig;
                    }
                }

                // Ekstrahiraj guestDates iz guestTaxConfig (za prave goste s visaInfoId)
                let guestDates: any[] | undefined = undefined;
                if (parsedGuestTaxConfig) {
                    const dates: any[] = [];
                    
                    // Iz adults
                    if (parsedGuestTaxConfig.adults && Array.isArray(parsedGuestTaxConfig.adults)) {
                        parsedGuestTaxConfig.adults.forEach((adult: any) => {
                            if (adult.visaInfoId) {
                                dates.push({
                                    id: adult.visaInfoId,
                                    checkIn: adult.checkInTimestamp || null,
                                    checkOut: adult.checkOutTimestamp || null,
                                });
                            }
                        });
                    }
                    
                    // Iz children
                    if (parsedGuestTaxConfig.children && Array.isArray(parsedGuestTaxConfig.children)) {
                        parsedGuestTaxConfig.children.forEach((child: any) => {
                            if (child.visaInfoId) {
                                dates.push({
                                    id: child.visaInfoId,
                                    checkIn: child.checkInTimestamp || null,
                                    checkOut: child.checkOutTimestamp || null,
                                });
                            }
                        });
                    }
                    
                    if (dates.length > 0) {
                        guestDates = dates;
                    }
                }

                const newOffer: PriceOffer = {
                    accommodationPriceListId,
                    checkInTimestamp,
                    checkOutTimestamp,
                    adultsNumber,
                    childrenNumber,
                    priceOfferIntervals: reservationPriceOfferIntervals,
                    openPrice,
                    canceledReservationInvoicingStatus,
                    id,
                    board,
                    guestTaxConfig: parsedGuestTaxConfig,
                    guestDates,
                };

                const offers: PriceOffer[] = [...rememberedAccommodationPriceInfo];
                offers.push(newOffer);

                const res: ReservationModelWithModelsIncluded = { ...reservation };
                res.rememberedAccommodationPriceInfo = offers;

                await saveOrUpdateReservation(res);
            }
        }
    } else if (groupUuid) {
        const groupReservationsArray: ReservationModelWithModelsIncluded[] =
            useStore.getState().state.checkoutInvoice.groupReservationsArray;

        const currentTime = new Date().getTime();

        if (groupReservationsArray?.every((r) => r?.statusEnum === ReservationStatus.closed)) {
            throw new Error('Reservation is closed!');
        } else {
            for (const reservation of groupReservationsArray) {
                const {
                    accommodationPriceListId,
                    checkInTimestamp,
                    checkOutTimestamp,
                    adultsNumber,
                    childrenNumber,
                    id,
                    rememberedAccommodationPriceInfo,
                    openPrice,
                    canceledReservationInvoicingStatus,
                    board,
                    guestTaxConfig,
                } = reservation;

                if (rememberedAccommodationPriceInfo) {
                    const offers: PriceOffer[] = [...rememberedAccommodationPriceInfo];
                    const lastOffer: PriceOffer = offers[offers.length - 1];
                    const reservationPriceOfferIntervals: PriceOfferInterval[] = priceOfferIntervals[id]
                        ? priceOfferIntervals[id]
                        : lastOffer.priceOfferIntervals;
                    const reservationFromGroupOfferMismatch: boolean = checkReservationFromGroupOfferMismatch(
                        reservationPriceOfferIntervals,
                        lastOffer,
                        reservation
                    );

                    if (reservationFromGroupOfferMismatch) {
                        // Parsiraj guestTaxConfig ako je string
                        let parsedGuestTaxConfig = null;
                        if (guestTaxConfig) {
                            if (typeof guestTaxConfig === 'string') {
                                try {
                                    parsedGuestTaxConfig = JSON.parse(guestTaxConfig);
                                } catch (e) {
                                    parsedGuestTaxConfig = null;
                                }
                            } else {
                                parsedGuestTaxConfig = guestTaxConfig;
                            }
                        }

                        // Ekstrahiraj guestDates iz guestTaxConfig (za prave goste s visaInfoId)
                        let guestDates: any[] | undefined = undefined;
                        if (parsedGuestTaxConfig) {
                            const dates: any[] = [];
                            
                            // Iz adults
                            if (parsedGuestTaxConfig.adults && Array.isArray(parsedGuestTaxConfig.adults)) {
                                parsedGuestTaxConfig.adults.forEach((adult: any) => {
                                    if (adult.visaInfoId) {
                                        dates.push({
                                            id: adult.visaInfoId,
                                            checkIn: adult.checkInTimestamp || null,
                                            checkOut: adult.checkOutTimestamp || null,
                                        });
                                    }
                                });
                            }
                            
                            // Iz children
                            if (parsedGuestTaxConfig.children && Array.isArray(parsedGuestTaxConfig.children)) {
                                parsedGuestTaxConfig.children.forEach((child: any) => {
                                    if (child.visaInfoId) {
                                        dates.push({
                                            id: child.visaInfoId,
                                            checkIn: child.checkInTimestamp || null,
                                            checkOut: child.checkOutTimestamp || null,
                                        });
                                    }
                                });
                            }
                            
                            if (dates.length > 0) {
                                guestDates = dates;
                            }
                        }

                        const newOffer: PriceOffer = {
                            accommodationPriceListId,
                            checkInTimestamp,
                            checkOutTimestamp,
                            adultsNumber,
                            childrenNumber,
                            priceOfferIntervals: reservationPriceOfferIntervals,
                            timestamp: currentTime,
                            openPrice,
                            canceledReservationInvoicingStatus,
                            id,
                            board,
                            guestTaxConfig: parsedGuestTaxConfig,
                            guestDates,
                        };

                        offers.push(newOffer);
                        const res = { ...reservation };
                        res.rememberedAccommodationPriceInfo = offers;
                        res.previousGroupUuid = null;
                        await saveOrUpdateReservation(res);
                    }
                }
            }
        }
    }
};

export const undoLastOffer = async (props: ReservationTypeBody) => {
    const { reservationId = null, groupUuid = null } = props;
    if (reservationId) {
        const reservation: ReservationModelWithModelsIncluded = useStore.getState().state.checkoutInvoice.reservation;

        if (reservation?.statusEnum === ReservationStatus.closed) {
            throw new Error('Reservation is closed!');
        } else {
            const { rememberedAccommodationPriceInfo } = reservation;
            if (rememberedAccommodationPriceInfo) {
                const offers = [...rememberedAccommodationPriceInfo];
                offers.pop();
                const res = { ...reservation };
                res.rememberedAccommodationPriceInfo = offers;
                await saveOrUpdateReservation(res);
            }
        }
    } else if (groupUuid) {
        const groupReservationsArray: ReservationModelWithModelsIncluded[] =
            useStore.getState().state.checkoutInvoice.groupReservationsArray;

        const allReservationOffersTimestamps: number[] = [];
        groupReservationsArray.forEach((r: ReservationModelWithModelsIncluded) => {
            const { rememberedAccommodationPriceInfo } = r;
            if (rememberedAccommodationPriceInfo && rememberedAccommodationPriceInfo.length > 0) {
                const lastOffer = rememberedAccommodationPriceInfo[rememberedAccommodationPriceInfo.length - 1];
                const { timestamp } = lastOffer;
                if (timestamp) {
                    allReservationOffersTimestamps.push(timestamp);
                }
            }
        });

        const maxOfferTimestamp = Math.max(...allReservationOffersTimestamps);
        if (groupReservationsArray?.every((r) => r?.statusEnum === ReservationStatus.closed)) {
            throw new Error('Reservation is closed!');
        } else {
            for (const reservation of groupReservationsArray) {
                const { rememberedAccommodationPriceInfo } = reservation;

                if (rememberedAccommodationPriceInfo) {
                    const offers: PriceOffer[] = [...rememberedAccommodationPriceInfo];
                    const lastOffer: PriceOffer = offers[offers.length - 1];
                    if (lastOffer?.timestamp === maxOfferTimestamp) {
                        offers.pop();
                        const res = { ...reservation };
                        res.rememberedAccommodationPriceInfo = offers;
                        await saveOrUpdateReservation(res);
                    }
                }
            }
        }
    }
};

export const restorePreviousCheckoutDate = async (
    targetReservation: ReservationModelWithModelsIncluded,
    location: any,
    reservationId: number | null,
    groupUuid: string | null
) => {
    const { rememberedAccommodationPriceInfo } = targetReservation;

    if (rememberedAccommodationPriceInfo && rememberedAccommodationPriceInfo.length > 0) {
        const lastOffer: PriceOffer = rememberedAccommodationPriceInfo[rememberedAccommodationPriceInfo.length - 1];
        const { checkOutTimestamp } = lastOffer;

        const res: ReservationModelWithModelsIncluded = { ...targetReservation };
        res.checkOutTimestamp = checkOutTimestamp;
        try {
            await saveOrUpdateReservation(res);
            await loadCheckoutInvoice({ reservationId, groupUuid, location });
        } catch (err: any) {
            if (err.desc && err.desc.length > 0) {
                useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'stayoverOverlap'], {
                    overlapReservations: err.desc,
                    option: null,
                    type: null,
                });
            } else {
                console.log(err);
            }
        }
    }
};

export const createOrJoinNotConnectedConsumptionInvoices = async (
    consumptionInvoice: InvoiceModel,
    reservationId: number | null,
    groupUuid: string | null
) => {
    clearInvoicePreview();
    const { invoice, invoiceItems } = await _createOrJoinNotConnectedConsumptionInvoices({
        reservationId,
        groupUuid,
    });
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoice'], invoice);
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoiceItems'], invoiceItems);
    if (consumptionInvoice.id) {
        await addConnectedInvoice(consumptionInvoice.id, reservationId, groupUuid);
    }
};
export const setAccommodationInvoice = async () => {
    const invoice = useStore.getState().state.checkoutInvoice.invoice;
    if (invoice.id === undefined) {
        const accommodationInvoice = useStore.getState().state.checkoutInvoice.accommodationInvoice;
        useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'invoice'], accommodationInvoice);
        useStore
            .getState()
            .setNestedProperty(['state', 'checkoutInvoice', 'invoiceItems'], accommodationInvoice.InvoiceItems);
    }
};

interface AddOrRemoveProps {
    invoice: InvoiceModelWithInvoiceItems;
    reservationId?: number | null;
    groupUuid?: string | null;
    add: boolean;
}

export const addOrRemoveInvoice = async (props: AddOrRemoveProps) => {
    const { invoice, add, reservationId, groupUuid } = props;
    await _updateInvoiceAndRecalculateStatus(invoice, reservationId,groupUuid ,add);
    const posTerminalInvoices: InvoiceModelWithInvoiceItems[] =
        useStore.getState().state.checkoutInvoice.posTerminalInvoices;
    const minibarInvoices: InvoiceModelWithInvoiceItems[] = useStore.getState().state.checkoutInvoice.minibarInvoices;
    const proformaInvoices: InvoiceModelWithInvoiceItems[] = useStore.getState().state.checkoutInvoice.proformaInvoices;

    const allProformas = [];

    for (const posTerminalInvoice of posTerminalInvoices) {
        allProformas.push(posTerminalInvoice);
    }
    for (const proformaInvoice of proformaInvoices) {
        allProformas.push(proformaInvoice);
    }
    for (const minibarInvoice of minibarInvoices) {
        allProformas.push(minibarInvoice);
    }
    if (invoice.terminalType === 'posTerminal') {
        const newPosTerminalInvoices = add
            ? [...posTerminalInvoices, invoice]
            : posTerminalInvoices.filter((i: InvoiceModelWithInvoiceItems) => i.id !== invoice.id);
        useStore
            .getState()
            .setNestedProperty(['state', 'checkoutInvoice', 'posTerminalInvoices'], newPosTerminalInvoices);
    } else if (invoice.terminalType === 'minibar') {
        const newMinibarInvoices = add
            ? [...minibarInvoices, invoice]
            : minibarInvoices.filter((i: InvoiceModelWithInvoiceItems) => i.id !== invoice.id);
        useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'minibarInvoices'], newMinibarInvoices);
    } else if (invoice.terminalType === 'reservation' || invoice.terminalType === 'reservationConsumption') {
        // može se dogoditi samo u ovom slučaju da imamo i connected invoices
        const { connectedInvoices } = invoice;
        const targetInvoices = allProformas.filter((i) => {
            if (connectedInvoices && connectedInvoices.includes(Number(i.id))) {
                return i;
            } else {
                return null;
            }
        });

        if (!add) {
            for (const targetInvoice of targetInvoices) {
                const editedInvoice = { ...targetInvoice };
                editedInvoice.connectedInvoiceProcessed = null;
                await _saveInvoice(editedInvoice);
            }
            if (groupUuid) {
                await loadCheckoutInvoice({ reservationId: null, groupUuid });
            } else {
                if (reservationId) {
                    await loadCheckoutInvoice({ reservationId, groupUuid: null });
                }
            }
        } else {
            const newProformaInvoices = add
                ? [...proformaInvoices, invoice]
                : proformaInvoices.filter((i: InvoiceModelWithInvoiceItems) => i.id !== invoice.id);
            useStore
                .getState()
                .setNestedProperty(['state', 'checkoutInvoice', 'proformaInvoices'], newProformaInvoices);
        }
    }
};

export const splitInvoice = async (
    posTerminalConsumptions: PosTerminalConsumption[][],
    posTerminalId: number,
    invoice: InvoiceModelWithInvoiceItems,
    notes?: (string | null)[]
) => {
    const { customerId, companyId, reservationId, groupUuid, connectedInvoices } = invoice;

    // Track original indices before filtering empty consumptions
    const invoicesData: { consumption: PosTerminalConsumption[]; originalIndex: number }[] = [];

    posTerminalConsumptions.forEach((posTerminalConsumption, idx) => {
        const validPosTerminalConsumption = posTerminalConsumption.find((p: any) => Number(p.newPrice) > 0);
        if (validPosTerminalConsumption) {
            invoicesData.push({
                consumption: posTerminalConsumption.filter((f: any) => Number(f.newPrice) > 0),
                originalIndex: idx,
            });
        }
    });

    const totalInvoices = invoicesData.length;

    for (let i = 0; i < totalInvoices; i++) {
        const { consumption, originalIndex } = invoicesData[i];
        const isLastInvoice = i === totalInvoices - 1;

        const newInvoice = await _loadPosTerminalPendigInvoice(
            posTerminalId,
            customerId,
            companyId,
            reservationId,
            groupUuid
        );

        // Add note if exists for this invoice
        const noteForThisInvoice = notes?.[originalIndex] || null;
        if (noteForThisInvoice) {
            newInvoice.note = newInvoice.note
                ? `${newInvoice.note}\n${noteForThisInvoice}`
                : noteForThisInvoice;
        }

        // Na zadnjem pozivu šaljemo flag za disconnect connected invoices
        const disconnectInvoiceIds = isLastInvoice ? connectedInvoices : null;

        await _issuePosInvoice(
            consumption,
            posTerminalId,
            reservationId,
            newInvoice,
            disconnectInvoiceIds  // <-- NOVI PARAMETAR
        );
    }
};

export const checkForClientDiscount = (invoice: InvoiceModel | InvoiceModelWithInvoiceItems): number | null => {
    let loyaltyProgramId = null;
    if (invoice?.companyId) {
        const _companyInfo = invoice?.companyInfo;
        const companyInfo = _companyInfo ? JSON.parse(_companyInfo) : null;
        if (companyInfo && companyInfo.loyaltyProgramId) {
            loyaltyProgramId = companyInfo.loyaltyProgramId;
        }
    }
    if (invoice?.customerId && !loyaltyProgramId) {
        const _customerInfo = invoice?.customerInfo;
        const customerInfo = _customerInfo ? JSON.parse(_customerInfo) : null;

        if (customerInfo && customerInfo.loyaltyProgramId) {
            loyaltyProgramId = customerInfo.loyaltyProgramId;
        }
    }

    return loyaltyProgramId;
};

export const getLoyaltyProgram = (): any => {
    const loyaltyProgram: any = useStore.getState().state.checkoutInvoice.loyaltyProgram;
    return loyaltyProgram;
};

export const setLoyaltyProgram = (loyaltyProgram: any) => {
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'loyaltyProgram'], loyaltyProgram);
};



/**
 * Toggle simple view za preview (lokalni toggle, ne sprema se dok se ne izda račun)
 * Simplifikacija se primjenjuje u PlainInvoiceView na svakom renderu - invoiceItems u storeu
 * uvijek ostaju originalni podaci s backenda.
 */
export const toggleSimpleView = (enabled: boolean) => {
    useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'simpleViewEnabled'], enabled);
};

// Bazni PLU po tipu za Simple View
const TYPE_BASE_PLU: Record<string, number> = {
    'accommodation': 9000,
    'tax': 9100,
    'insurance': 9200,
    'posTerminal': 9300,
    'services': 9400,
    'consumption': 9500,
    'avans': 9600,
    'other': 9700,
};

// Raspon koji treba zaštititi od korištenja u PosItem formi
export const RESERVED_PLU_RANGE = { min: 9000, max: 9999 };

/**
 * Generira PLU za Simple View stavku na osnovu tipa i poreznih stopa.
 * Bazni PLU ovisi o tipu, offset ovisi o kombinaciji poreza.
 */
const getSimpleViewPlu = (type: string, tax1: number, tax2: number, tax3: number): number => {
    const basePlu = TYPE_BASE_PLU[type] || 9700;
    
    // Encode taxes into offset (0-99)
    // t1: 0=nema PDV, 1=ima PDV (bilo koji %)
    // t2: 0=nema, 1=ima drugi porez (npr PNP)
    // t3: 0=nema, 1=ima treći porez
    const t1 = Number(tax1) > 0 ? 1 : 0;
    const t2 = Number(tax2) > 0 ? 1 : 0;
    const t3 = Number(tax3) > 0 ? 1 : 0;
    
    const offset = t1 * 10 + t2 * 2 + t3;
    return basePlu + offset;
};

/**
 * Simplifies invoice items by grouping them by TYPE and TAX PERCENTAGES.
 * Used for fiscal printing and A4 rendering when simpleView is enabled.
 * Does NOT modify database - only transforms items on-the-fly.
 * @param translateFn - opcijska funkcija za prijevod (backend: backendTranslate, frontend: translate)
 */
export const simplifyInvoiceItems = (
    invoiceItems: InvoiceItemsModel[],
    translateFn?: (text: string) => string
): InvoiceItemsModel[] => {
    if (!invoiceItems || invoiceItems.length === 0) {
        return [];
    }

    const translate = translateFn || ((text: string) => text);

    const typeNameMap: Record<string, string> = {
        accommodation: 'Accommodation',
        tax: 'Accommodation tax',
        insurance: 'Insurance',
        posTerminal: useStore.getState().invoicingSettings?.simplifiedViewPosItemName || 'Goods',
        services: 'Services',
        avans: 'Advance payment',
        consumption: 'Consumption',
        other: 'Other',
    };

    const groupedItems: { [key: string]: InvoiceItemsModel[] } = {};

    for (const item of invoiceItems) {
        const type = item.type || 'other';
        const tax1 = Number(item.taxPercentage1) || 0;
        const tax2 = Number(item.taxPercentage2) || 0;
        const tax3 = Number(item.taxPercentage3) || 0;
        const groupKey = `${type}_${tax1}_${tax2}_${tax3}`;
        
        if (!groupedItems[groupKey]) {
            groupedItems[groupKey] = [];
        }
        groupedItems[groupKey].push(item);
    }

    const simplifiedItems: InvoiceItemsModel[] = [];

    for (const groupKey in groupedItems) {
        const items = groupedItems[groupKey];
        const firstItem = items[0];

        let totalBruttoValueWithDiscount = 0;
        let totalNettoValueWithDiscount = 0;
        let totalTax1Value = 0;
        let totalTax2Value = 0;
        let totalTax3Value = 0;
        let totalTaxValue = 0;
        let totalBruttoUnitsValue = 0;
        let totalBrutoValueDiscount = 0;
        let totalDiscountValue = 0;
        let totalValueWithDiscount = 0;

        for (const item of items) {
            totalBruttoValueWithDiscount += Number(item.bruttoValueWithDiscount) || 0;
            totalNettoValueWithDiscount += Number(item.nettoValueWithDiscount) || 0;
            totalTax1Value += Number(item.tax1ValueWithDiscount) || 0;
            totalTax2Value += Number(item.tax2ValueWithDiscount) || 0;
            totalTax3Value += Number(item.tax3ValueWithDiscount) || 0;
            totalTaxValue += Number(item.totalTaxValue) || 0;
            totalBruttoUnitsValue += Number(item.bruttoUnitsValue) || 0;
            totalBrutoValueDiscount += Number(item.brutoValueDiscount) || 0;
            totalDiscountValue += Number(item.discountValue) || 0;
            totalValueWithDiscount += Number(item.valueWithDiscount) || 0;
        }

        const itemType = firstItem.type || 'other';
        const typeNameKey = typeNameMap[itemType] || 'Other';
        const itemName = translate(typeNameKey); // PRIJEVOD
        
        const plu = getSimpleViewPlu(
            itemType,
            Number(firstItem.taxPercentage1) || 0,
            Number(firstItem.taxPercentage2) || 0,
            Number(firstItem.taxPercentage3) || 0
        );

        simplifiedItems.push({
            id: firstItem.id,
            invoiceId: firstItem.invoiceId ?? null,
            itemName: itemName,
            quantity: 1,
            unitPrice: round(totalBruttoValueWithDiscount),
            discountPercentage: 0,
            discountValue: round(totalDiscountValue),
            taxPercentage1: firstItem.taxPercentage1 ?? 0,
            taxPercentage2: firstItem.taxPercentage2 ?? 0,
            taxPercentage3: firstItem.taxPercentage3 ?? 0,
            taxIncludedInPrice: firstItem.taxIncludedInPrice,
            type: firstItem.type,
            subtype: firstItem.subtype ?? null,
            taxFreeCompany: firstItem.taxFreeCompany,
            bruttoUnitPrice: round(totalBruttoValueWithDiscount),
            bruttoValueWithDiscount: round(totalBruttoValueWithDiscount),
            bruttoUnitsValue: round(totalBruttoUnitsValue),
            brutoValueDiscount: round(totalBrutoValueDiscount),
            nettoUnitPrice: round(totalNettoValueWithDiscount),
            nettoValueWithDiscount: round(totalNettoValueWithDiscount),
            valueWithDiscount: round(totalValueWithDiscount),
            tax1ValueWithDiscount: round(totalTax1Value),
            tax2ValueWithDiscount: round(totalTax2Value),
            tax3ValueWithDiscount: round(totalTax3Value),
            totalTaxValue: round(totalTaxValue),
            posItemId: null,
            group: null,
            plu: plu,
            minibarLogId: null,
            recordedAt: null,
            roomInfoId: null,
        });
    }

    const typeOrder = ['accommodation', 'tax', 'insurance', 'services', 'posTerminal', 'consumption', 'avans', 'other'];
    return simplifiedItems.sort((a, b) => {
        const idxA = typeOrder.indexOf(a.type || 'other');
        const idxB = typeOrder.indexOf(b.type || 'other');
        return (idxA === -1 ? 999 : idxA) - (idxB === -1 ? 999 : idxB);
    });
};